/* Fri frakt-kommunikasjon for gursliberg.no (CRO P1 #4, sept 2026).
   Progressbar i handlekurv/kurv-skuff + trygghetslinje under kjoepsknappen paa PDP.
   GRENSE: settes fra data-gb-threshold paa script-taggen, i oere (30000 = 300 kr).
   Maa holdes i synk med fraktprofilen i Shopify admin > Frakt og levering.

   NB PDP: temaet rendrer TRE .product-form__buttons (ett skjema per digitalt
   format), og de to foerste er skjulte. Vi forankrer derfor til .add-to__cart,
   som omslutter alle skjemaene og ligger rett over betalingsikonene.

   ENDRET 19.09.2026: trygghetslinjas punkt 2 gikk fra "14 dagers angrerett" til
   "Direkte fra forlaget". Gunhild ba om dette 01.09 - hun vil ikke ha retur og
   angrerett nevnt i kjoepsoeyeblikket. Sterkeste erstatning ville vaert
   leveringstid, men det tallet har vi ikke faatt.

   NB regex: ingen backslash-escapes her. Filene skrives via Admin API-ets
   themeFilesUpsert, og GraphQL block-strings tolker ikke \ som escape. */
(function () {
  var el = document.currentScript;
  var THRESHOLD = parseInt((el && el.getAttribute('data-gb-threshold')) || '30000', 10);
  var MONEY_FMT = (el && el.getAttribute('data-gb-money')) || '{{amount_with_comma_separator}} kr';

  function money(cents) {
    // Bokpriser er hele kroner - dropp oerene naar de er null (300 kr, ikke 300,00 kr)
    var v = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',');
    return MONEY_FMT.replace(/{{[^}]*}}/, v);
  }

  function visible(node) {
    return node && node.offsetParent !== null && node.getBoundingClientRect().height > 0;
  }

  function render(container, total) {
    if (!container) return;
    var bar = container.querySelector('.gb-shipping-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'gb-shipping-bar';
      bar.innerHTML = '<p class="gb-shipping-bar__text"></p><div class="gb-shipping-bar__track"><div class="gb-shipping-bar__fill"></div></div>';
      container.insertBefore(bar, container.firstChild);
    }
    var remaining = THRESHOLD - total;
    var reached = remaining <= 0;
    bar.classList.toggle('gb-shipping-bar--reached', reached);
    bar.querySelector('.gb-shipping-bar__text').innerHTML = reached
      ? 'Du har fri frakt på denne ordren.'
      : 'Du mangler <strong>' + money(remaining) + '</strong> til fri frakt.';
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    bar.querySelector('.gb-shipping-bar__fill').style.width = pct + '%';
  }

  function targets() {
    return [
      document.querySelector('cart-drawer .drawer__footer'),
      document.querySelector('#main-cart-footer .cart__footer') || document.querySelector('#main-cart-footer')
    ].filter(Boolean);
  }

  function update() {
    var t = targets();
    if (!t.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        t.forEach(function (c) {
          var old = c.querySelector('.gb-shipping-bar');
          if (cart.item_count === 0) { if (old) old.remove(); }
          else { render(c, cart.total_price); }
        });
      })
      .catch(function () {});
  }

  function pdpTrust() {
    if (document.querySelector('.gb-pdp-trust')) return;
    var host = document.querySelector('.add-to__cart');
    if (!visible(host)) {
      host = Array.prototype.filter.call(document.querySelectorAll('.product-form__buttons'), visible)[0];
    }
    if (!host || !host.parentNode) return;
    var box = document.createElement('div');
    box.className = 'gb-pdp-trust';
    box.innerHTML = '<ul><li>Fri frakt på ordrer over ' + money(THRESHOLD) + '</li><li>Direkte fra forlaget</li></ul>';
    host.parentNode.insertBefore(box, host.nextSibling);
  }

  function init() { update(); pdpTrust(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = a && a.url ? a.url : String(a || '');
    var p = _fetch.apply(this, arguments);
    if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1) {
      p.then(function () { setTimeout(update, 60); }).catch(function () {});
    }
    return p;
  };
})();